import React, { useState, useEffect, useRef } from 'react';
import { useDebounce } from 'use-debounce';
import { Input } from "semantic-ui-react";
export default function DebouncedInput(props) {
  const {style,
         type,
         name,
         placeholder,
         defaultValue,
         onChange,
         onChangeDebounced
        } = props;
  const [text, setText] = useState(defaultValue);
  const [value] = useDebounce(text, 1000);
  const isFirstRun = useRef(true);

  useEffect(()=>{
    if (onChangeDebounced && !isFirstRun.current) {
      onChangeDebounced(value)
    }
    isFirstRun.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <div style={{width:"100%"}}>
      <Input
        style={style}
        type={type}
        name={name}
        placeholder={placeholder}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          if (onChange) {
            onChange(e.target.value);
          }
        }}
      />

    </div>
  );
}